/**
 * Payment Status Chart Component
 * Displays payment status breakdown
 */

import React from "react";
import {
	Bar,
	BarChart,
	CartesianGrid,
	Legend,
	ResponsiveContainer,
	Tooltip,
	XAxis,
	YAxis,
} from "recharts";

interface PaymentStatusChartProps {
	data: Array<{
		status: string;
		count: number;
		amount: number;
	}>;
}

const PaymentStatusChart: React.FC<PaymentStatusChartProps> = ({ data }) => {
	const formatCurrency = (value: number) => {
		return new Intl.NumberFormat("en-NG", {
			style: "currency",
			currency: "NGN",
			minimumFractionDigits: 0,
			maximumFractionDigits: 0,
		}).format(value);
	};

	return (
		<div className="bg-card border border-border rounded-lg p-6">
			<h3 className="text-lg font-semibold text-foreground mb-4">
				Payment Status Overview
			</h3>
			<ResponsiveContainer width="100%" height={300}>
				<BarChart data={data}>
					<CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
					<XAxis
						dataKey="status"
						stroke="hsl(var(--muted-foreground))"
						style={{ fontSize: "12px" }}
					/>
					<YAxis
						stroke="hsl(var(--muted-foreground))"
						style={{ fontSize: "12px" }}
					/>
					<Tooltip
						contentStyle={{
							backgroundColor: "hsl(var(--card))",
							border: "1px solid hsl(var(--border))",
							borderRadius: "6px",
						}}
						formatter={(value: number, name: string) => {
							if (name === "amount") return formatCurrency(value);
							return value;
						}}
					/>
					<Legend />
					<Bar
						dataKey="count"
						fill="hsl(var(--primary))"
						name="Count"
						radius={[8, 8, 0, 0]}
					/>
					<Bar
						dataKey="amount"
						fill="hsl(var(--success))"
						name="Amount"
						radius={[8, 8, 0, 0]}
					/>
				</BarChart>
			</ResponsiveContainer>
		</div>
	);
};

export default PaymentStatusChart;
